module.exports = __webpack_public_path__ + "static/media/database-blue.c3f84826.svg";